window.CaseStudiesGrid = () => {
    return {
        caseStudyOpened: false,
        videoSource: '',
        videoType: '',
    };
};
